var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSearchNoList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60352 11.0003C1.60352 6.33539 1.60352 4.00292 3.05272 2.5537C4.50194 1.10449 6.83441 1.10449 11.4993 1.10449C16.1642 1.10449 18.4967 1.10449 19.946 2.5537C21.3952 4.00292 21.3952 6.33539 21.3952 11.0003C21.3952 15.6652 21.3952 17.9977 19.946 19.447C18.4967 20.8962 16.1642 20.8962 11.4993 20.8962C6.83441 20.8962 4.50194 20.8962 3.05272 19.447C1.60352 17.9977 1.60352 15.6652 1.60352 11.0003Z",
    stroke: "#999999",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6243 14.1253L16.7077 16.2087M15.666 10.4795C15.666 7.89063 13.5674 5.79199 10.9785 5.79199C8.38965 5.79199 6.29102 7.89063 6.29102 10.4795C6.29102 13.0683 8.38965 15.167 10.9785 15.167C13.5674 15.167 15.666 13.0683 15.666 10.4795Z",
    stroke: "#A7A8AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSearchNoList);
export default __webpack_public_path__ + "static/media/icn_search_noList.758ec00ecc87b28d272c1aca1be3ae15.svg";
export { ForwardRef as ReactComponent };